import React from 'react'
import Heading from './items/Heading'
import CheckList from './items/CheckList'
import Divider from './items/Divider'
import Dropdown from './items/Dropdown'
import SimpleQuestion from './items/SimpleQuestion'
import SingleChoice from './items/SingleChoice'
import MultiChoice from './items/MultiChoice'
import RatingScale from './items/RatingScale'
import YesNoQuestion from './items/YesNoQuestion'
import Notes from './items/Notes'
import Table from './items/Table'
import File from './items/File'
import Date from './items/Date'
import TextField from './items/TextField'
import FormattingTextField from './items/FormattingTextField'
import Signature from './items/Signature'
import isNull from '../../../../../../../../../utils/NullChecking'

const RenderField = ({ item, setItem, activeAccordion, isGroupNote, ...props }) => {
  switch (!isNull(item?.ItemID) && item.ItemID.split('-')[0]) {
    // Use the base ID to determine the type
    case 'Heading':
      return <Heading item={item} isGroupNote={isGroupNote} />;

    case 'TextField':
      return <TextField item={item} isGroupNote={isGroupNote} />;

    case 'FormattingTextField':
      return <FormattingTextField item={item} isGroupNote={isGroupNote} />;

    // case 'Checklist':
    case 'CheckList':
      return <CheckList item={item} setItem={setItem} activeAccordion={activeAccordion} validations={props?.validations} itemCount={props?.itemCount} />;

    case 'Divider':
      return <Divider item={item} setItem={setItem} activeAccordion={activeAccordion} />;

    case 'Dropdown':
      return <Dropdown item={item} setItem={setItem} activeAccordion={activeAccordion} validations={props?.validations} itemCount={props?.itemCount} isGroupNote={isGroupNote} />;

    case 'SimpleQuestion':
      return <SimpleQuestion item={item} setItem={setItem} activeAccordion={activeAccordion} validations={props?.validations} itemCount={props?.itemCount} isGroupNote={isGroupNote} />;

    case 'SingleChoice':
      return <SingleChoice item={item} setItem={setItem} activeAccordion={activeAccordion} validations={props?.validations} itemCount={props?.itemCount} isGroupNote={isGroupNote} itemRefKey={props?.itemRefKey} />;

    case 'MultiChoice':
      return <MultiChoice item={item} setItem={setItem} activeAccordion={activeAccordion} validations={props?.validations} itemCount={props?.itemCount} isGroupNote={isGroupNote} itemRefKey={props?.itemRefKey} />;

    case 'RatingScale':
      return <RatingScale item={item} setItem={setItem} activeAccordion={activeAccordion} isGroupNote={isGroupNote} />;

    case 'YesNoQuestion':
      return <YesNoQuestion item={item} setItem={setItem} activeAccordion={activeAccordion} validations={props?.validations} itemCount={props?.itemCount} isGroupNote={isGroupNote} itemRefKey={props?.itemRefKey}/>;

    case 'Notes':
      return <Notes item={item} setItem={setItem} activeAccordion={activeAccordion} isGroupNote={isGroupNote} />;

    case 'Table':
      return <Table item={item} setItem={setItem} activeAccordion={activeAccordion} validations={props?.validations} itemCount={props?.itemCount} isGroupNote={isGroupNote} />;

    case 'File':
      return <File item={item} setItem={setItem} activeAccordion={activeAccordion} itemCount={props?.itemCount} isGroupNote={isGroupNote} />;

    case 'Image':
      return <File item={item} setItem={setItem} activeAccordion={activeAccordion} validations={props?.validations} itemCount={props?.itemCount} isGroupNote={isGroupNote} />;

    case 'Date':
      return <Date item={item} setItem={setItem} activeAccordion={activeAccordion} validations={props?.validations} itemCount={props?.itemCount} isGroupNote={isGroupNote} />;

    case 'Signature':
      return <Signature item={item} setItem={setItem} activeAccordion={activeAccordion} patientName={props?.patientName} validations={props?.validations} itemCount={props?.itemCount} isGroupNote={isGroupNote} />;

    default:
      return null;
  }
}

export default RenderField